<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <div class="row">
            <div class="col-md-4 mb-3">
                <div class="form-group">
                    <label for="boltNutWasherMaterialType">Bolt, Nut, Washer Material Type Required</label>
                    <input
                        type="text"
                        class="form-control"
                        id="boltNutWasherMaterialType"
                        [(ngModel)]="target.boltNutWasherMaterialType"
                        name="boltNutWasherMaterialType"
                    />
                </div>
            </div>
            <div class="col-md-4 mb-3">
                <div class="form-group">
                    <label for="highTorqueRequired">High Torque Required</label>
                    <input
                        type="text"
                        class="form-control"
                        id="highTorqueRequired"
                        [(ngModel)]="target.highTorqueRequired"
                        name="highTorqueRequired"
                    />
                </div>
            </div>
            <div class="col-md-4 mb-3">
                <div class="form-group">
                    <label for="flangeTypeRequired">Flange Type Required</label>
                    <input
                        type="text"
                        class="form-control"
                        id="flangeTypeRequired"
                        [(ngModel)]="target.flangeTypeRequired"
                        name="flangeTypeRequired"
                    />
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" (click)="cancel()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="save()">Save</button>
    </div>
</form>
